<frontend-pull-refresh></frontend-pull-refresh>

<section class="pb-3 px-3">
  <section class="invoices-wrapper">
    <h1 class="pt-3">Subscription Plans</h1>

    <ngb-alert [dismissible]="false" *ngIf="isOffline" type="info" class="text-center">
      <div class="d-flex flex-row justify-content-center align-items-center">
        <tr-icon [icon]="icon.info" classes="pr-2"></tr-icon>

        <p class="my-0">The subscription is managed offline. Please contact your account representative for more information.</p>
      </div>
    </ngb-alert>

    <ngb-alert [dismissible]="false" *ngIf="currentPricePlan && showPremiumPlanAlert" type="success" class="text-center">
      <strong>{{ planTiersMap[currentPricePlan.tier] }} Plan.</strong> {{ location?.usage?.total | number }} of {{ location?.usage?.limit | number }} messages used this month. Your usage will reset on {{ location?.usage?.nextReset | trDateFormat: 'M/D h:mm a': timezone }}.
    </ngb-alert>

    <div class="d-flex flex-row justify-content-center w-100" *ngIf="currentPricePlan?.outdated">
      <ngb-alert [dismissible]="false" type="warning-custom" class="text-center">
        <div class="d-flex flex-row justify-content-center align-items-center">
          <span>
            <strong class="pr-1">Notice:</strong>Plan <strong class="px-1">{{currentPricePlan?.name}}</strong> is no longer supported.
            We recommend you subscribe to one of our starter or business plans.
          </span>
        </div>
      </ngb-alert>
    </div>

    <div class="d-flex flex-row justify-content-center w-100">
      <ngb-alert [dismissible]="false" type="warning-custom" *ngIf="!canceledSubscription && account?.subscriptionType === subscriptionType.recurly && location?.recurly?.subscription_state === subscriptionStates.active && pendingSubscriptionChange">
        <div class="d-flex flex-row justify-content-center align-items-center">
          <tr-icon [icon]="icon.infoHeavy" [color]="iconColor.orange" classes="pr-2"></tr-icon>

          <span>
          You've changed your billing plan to <strong class="d-inline mx-0">"{{pendingSubscriptionChange.name}}" (${{pendingSubscriptionChange.price}}/{{getPaymentPeriod(pendingSubscriptionChange)}})</strong>.
          Please note, the changes will take effect on <strong class="d-inline mx-0">{{pendingSubscriptionChange.startedAt | trDateFormat:'MMM DD, yyyy': timezone}}</strong>.
          <span *ngIf="isNotAvailableFreeSubscriptions(pendingSubscriptionChange)">Note: You have reached the limit of {{appVariables.FREE_PLAN_LOCATION_LIMIT}} Free locations. The location will be disabled when the current plan expires.</span>
        </span>
        </div>
      </ngb-alert>
    </div>

    <ng-container *ngIf="subscriptionState && (!currentPricePlan?.enabled || currentPricePlan?.outdated)">
      <ngb-alert [dismissible]="false" *ngIf="subscriptionState === subscriptionStates.paused" type="warning" class="text-center">
        Your subscription is paused. <strong>Notice: </strong>Plan <strong>{{currentPricePlan?.name}}</strong> is no longer supported.
        You can <a (click)="reactivateSubscription()"><strong>resume</strong></a> your current subscription, but we recommend you subscribe to one of our starter/business plans.
      </ngb-alert>

      <ngb-alert [dismissible]="false" *ngIf="canceledSubscription && (!currentPricePlan?.enabled || currentPricePlan?.outdated)" type="warning" class="text-center">
        Your subscription has been canceled. <strong>Notice: </strong>Plan <strong>{{currentPricePlan?.name}}</strong> is no longer supported.
        We recommend you subscribe to one of our starter/business plans.
      </ngb-alert>
    </ng-container>

    <div class="pt-3" *ngIf="who?.role !== 'admin' && (account?.subscriptionType === subscriptionType.trial || account?.subscriptionType === subscriptionType.recurly)">
      <div class="col-xs-12 text-center" *ngIf="(account?.subscriptionType === subscriptionType.trial && location.expiration_date > clock)">
        <p>
          <strong>You are using a trial account:</strong>
          Your trial will expire <strong>{{ trial }}</strong>.
        </p>
      </div>
      <div class="col-xs-12 text-center" *ngIf="(account?.subscriptionType === subscriptionType.trial && location.expiration_date <= clock)">
        <p>
          <strong>Your trial has expired!</strong>
          Please sign up for a subscription to continue using the {{ location.displayOptions.labels.brand }} service.
        </p>
      </div>
      <div class="col-sx-12 text-center" *ngIf="account?.subscriptionType === subscriptionType.recurly && canceledSubscription">
        <p>
          Your subscription has been canceled and will end on {{ currentSubscription.expiration_date | trDateFormat:'MMM DD, yyyy': timezone }}. <span *ngIf="currentPricePlan?.enabled && !currentPricePlan?.outdated">Click <a (click)="reactivateSubscription()"><strong>here</strong></a> to reactivate it. </span>
          <span *ngIf="countOfFreeLocations >= appVariables.FREE_PLAN_LOCATION_LIMIT">Note: You have reached the limit of {{appVariables.FREE_PLAN_LOCATION_LIMIT}} Free locations. The location will be disabled when the subscription ends.</span>
        </p>
      </div>
      <div class="col-xs-12 d-flex flex-row align-items-center justify-content-center" *ngIf="account?.subscriptionType === subscriptionType.recurly && subscriptionPausedText">
        <p [innerHTML]="subscriptionPausedText"></p>
        <p class="ml-1">
          <a (click)="cancelScheduledPause()" *ngIf="!inProgress"><strong>Cancel</strong></a>
          <a disabled *ngIf="inProgress"><strong>Canceling...</strong></a>
        </p>
      </div>
      <div class="col-xs-12 text-center" *ngIf="account?.subscriptionType === subscriptionType.recurly && (location?.expiration_date <= clock || location?.recurly?.subscription_state === subscriptionStates.expired)">
        <p><strong>Your subscription has expired.</strong>
          Please sign up for a new subscription to continue using the {{ location?.displayOptions?.labels?.brand }} service.</p>
      </div>
    </div>
    <div class="col-xs-12 text-center" *ngIf="account?.subscriptionType === subscriptionType.recurly && who?.location.recurly?.subscription_state === subscriptionStates.paused && !currentPricePlan?.outdated">
      <p>
        Your subscription is paused until {{ subscriptionResumeAt | trDateFormat:'MMM DD, yyyy': timezone }}. Click <a (click)="reactivateSubscription()"><strong>here</strong></a> to reactivate it immediately.
      </p>
    </div>

    <h4 *ngIf="who?.role === 'admin'" class="py-3 lead primary text-center">You're an admin.</h4>
  </section>

  <div *ngIf="!isOffline">
    <div class="plans-wrapper" *ngIf="location?.recurly">
      <div *ngIf="selectPricePlanForm" class="d-flex flex-column align-items-center" [formGroup]="selectPricePlanForm">
        <ng-container *ngIf="selectedStarterPlan && selectedBusinessPlan">
          <div class="term-grid-container">
            <div class="term-button-container">
              <p
                class="plan-type"
                [ngClass]="planTypeControl.value === planPeriods.Monthly ? periodButtonActiveClasses : periodButtonInactiveClasses"
                (click)="setPlanType(planPeriods.Monthly)"
              >
                Monthly
              </p>
              <p
                class="plan-type"
                [ngClass]="planTypeControl.value === planPeriods.Annual ? periodButtonActiveClasses : periodButtonInactiveClasses"
                (click)="setPlanType(planPeriods.Annual)"
              >
                Annual
              </p>
            </div>
          </div>
        </ng-container>

        <div class="plans mt-2 mb-2" *ngIf="who.account">
          <div class="payment-plan">
            <free-plan
              *ngIf="currentPricePlan && subscriptionState"
              [currentPricePlan]="currentPricePlan"
              [selectedPlan]="freePlan"
              [blockActions]="blockActions"
              [subscriptionState]="subscriptionState"
              [canceledSubscription]="canceledSubscription"
              (updateSubscription)="switchPlans($event)"
            ></free-plan>
          </div>

          <div class="payment-plan">
            <payment-plan
              *ngIf="selectedStarterPlan"
              [selectedPricePlan]="selectedStarterPlan"
              [currentPricePlan]="currentPricePlan"
              [subscriptionState]="subscriptionState"
              [accountRecurly]="account.recurly"
              [locationRecurly]="location.recurly"
              [limits]="starterPlansLimits"
              [blockActions]="blockActions"
              [isNotUsaOrCanadaRestaurant]="isNotUsaOrCanadaRestaurant"
              [canceledSubscription]="canceledSubscription"
              (switchPlans)="switchPlans($event)"
              (limitSelected)="onLimitSelected($event, planTiers.starter)"
              (activate)="activateSubscription($event)"
              (pause)="pauseSubscription()"
              (cancel)="cancelSubscription()"
              (reactivate)="reactivateSubscription()"
              [calcSavePercentageForAnnual]="calculateSavePercentage"
            ></payment-plan>
          </div>

          <div class="payment-plan">
            <payment-plan
              *ngIf="selectedBusinessPlan"
              [selectedPricePlan]="selectedBusinessPlan"
              [currentPricePlan]="currentPricePlan"
              [subscriptionState]="subscriptionState"
              [accountRecurly]="account.recurly"
              [locationRecurly]="location.recurly"
              [limits]="businessPlansLimits"
              [blockActions]="blockActions"
              [isNotUsaOrCanadaRestaurant]="isNotUsaOrCanadaRestaurant"
              [canceledSubscription]="canceledSubscription"
              (switchPlans)="switchPlans($event)"
              (limitSelected)="onLimitSelected($event, planTiers.business)"
              (activate)="activateSubscription($event)"
              (pause)="pauseSubscription()"
              (cancel)="cancelSubscription()"
              (reactivate)="reactivateSubscription()"
              [calcSavePercentageForAnnual]="calculateSavePercentage"
            ></payment-plan>
          </div>
        </div>

        <div class="plans-comparison">
          <a href="https://www.tablesready.com/pricing" target="_blank">Detailed Plan Comparison</a>
          <span class="px-2" *ngIf="!isMobile">|</span>
          <span [ngbTooltip]="!isAccountAdmin ? 'Only the account administrator can switch to the enterprise plan' : ''" container="body">
            <a
              [class.disabled]="!isAccountAdmin"
              href="https://www.tablesready.com/enterprise-contact"
              target="_blank"
            >Contact Us for Enterprise Plans with custom terms and pricing</a>
          </span>
        </div>
      </div>

      <div class="tables-wrapper">
        <table class="table table-sm-bordered tr-table" *ngIf="currentSubscription">
          <tbody>
          <tr class="d-none d-sm-table-row">
            <th>Plan</th>
            <th>Price*</th>
            <th>Period ends</th>
            <th>Status</th>
          </tr>
          <tr *ngIf="currentSubscription && currentSubscription.state !== subscriptionStates.expired">
            <td class="vertical-align-middle plan-column">
              <div>
                <tablesready-sms-usage
                  [subscriptionType]="account.subscriptionType"
                  [pricePlan]="currentPricePlan"
                  [usage]="location.usage"
                  [showPrice]="false"
                  [timezone]="timezone"
                ></tablesready-sms-usage>
              </div>
            </td>
            <td class="vertical-align-middle">
              <b>${{ currentSubscription.unit_amount || ((currentSubscription.unit_amount_in_cents || 0) / 100)}}</b>
            </td>
            <td class="vertical-align-middle">{{currentSubscription.expiration_date | trDateFormat:'MMM DD, yyyy': timezone}}</td>
            <td class="vertical-align-middle">
              <tablesready-subscription-state
                [state]="currentSubscription.state"
                [canceledSubscriptionChange]="canceledSubscriptionChange"
              ></tablesready-subscription-state>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="invoices-wrapper" *ngIf="currentSubscription">
      <tablesready-invoices
        *ngIf="account?.subscriptionType === subscriptionType.recurly && account?.recurly?.account_code"
        [timezone]="location.timezone"
        [locationSubscriptionId]="locationSubscriptionId"
        [isMobile]="isMobile"
        title="Current subscription invoices"
      ></tablesready-invoices>
    </div>
  </div>

</section>
